import { Component } from '@badideagames/engine';

export class Pipe extends Component {
  scored: boolean = false;
  gapY: number = 0;
}
